var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63659 1.83337H4.89492C2.88742 1.83337 1.83325 2.88754 1.83325 4.88587V6.62754C1.83325 8.62587 2.88742 9.68004 4.88575 9.68004H6.62742C8.62575 9.68004 9.67992 8.62587 9.67992 6.62754V4.88587C9.68909 2.88754 8.63492 1.83337 6.63659 1.83337Z",
    fill: "#BBC1C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.1145 1.83337H15.3728C13.3745 1.83337 12.3203 2.88754 12.3203 4.88587V6.62754C12.3203 8.62587 13.3745 9.68004 15.3728 9.68004H17.1145C19.1128 9.68004 20.167 8.62587 20.167 6.62754V4.88587C20.167 2.88754 19.1128 1.83337 17.1145 1.83337Z",
    fill: "#BBC1C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 12.3105H15.3728C13.3745 12.3105 12.3203 13.3647 12.3203 15.363V17.1047C12.3203 19.103 13.3745 20.1572 15.3728 20.1572H17.1145C19.1128 20.1572 20.167 19.103 20.167 17.1047V15.363C20.167 13.3647 19.1128 12.3105 17.1145 12.3105Z",
    fill: "#BBC1C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63659 12.3105H4.89492C2.88742 12.3105 1.83325 13.3647 1.83325 15.363V17.1047C1.83325 19.1122 2.88742 20.1664 4.88575 20.1664H6.62742C8.62575 20.1664 9.67992 19.1122 9.67992 17.1139V15.3722C9.68909 13.3647 8.63492 12.3105 6.63659 12.3105Z",
    fill: "#BBC1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPos);
export default __webpack_public_path__ + "static/media/ico-pos.51d647aa042d85c4e2196de1d427a2b3.svg";
export { ForwardRef as ReactComponent };